import { useParams } from "react-router-dom"

export const useIdParam = (key) => {
  const params = useParams()

  console.log("params", params)

  return params[key] ? parseInt(params[key], 10) : null
}
